import React from 'react'

/* Styles */
import './ConfrontationSwitchingAndRotation.css'

/* Modules */
import { Breadcrumb } from 'antd'
import { Link } from 'react-router-dom'
import TopBar from '../topBar/TopBar';

const ConfrontationSwitchingAndRotationView = (props) => {
    return (
        <div id='champContent'>

            <TopBar />
            <div style={{ height: '70px' }}></div>

            <div className="champsBlock">
                <Breadcrumb>
                    <Breadcrumb.Item><Link to={'/home'}>Início</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs', state: { userType: props.userType } }}>
                            Campeonatos
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={{ pathname: '/home/champs/' + props.champId }}>
                            {props.champObject.nome}
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Confrontos</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <div className='HomeContent'>
                <div className='ConfrontationSRCard'>
                    <Link
                        to={{ pathname: '/home/champs/' + props.champId + '/confrontation/switching' }}
                        style={{ color: 'rgba(0,0,0,0.65)' }}
                    >
                        <i className="fas fa-sitemap"></i>
                        <div className='HomeCardTitle'>Chaveamentos</div>
                    </Link>
                </div>

                <div className='ConfrontationSRCard'>
                    <Link
                        to={{ pathname: '/home/champs/' + props.champId + '/confrontation/rotation' }}
                        style={{ color: 'rgba(0,0,0,0.65)' }}
                    >
                        <i className="fas fa-random"></i>
                        <div className='HomeCardTitle'>Rodízios</div>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default ConfrontationSwitchingAndRotationView